import axios from "axios";
import {HOST_DEV} from "../common/constants";

const instance = axios.create({
    baseURL: HOST_DEV,
})


instance.interceptors.request.use(
    request => {

        request.headers.Authorization = `JWT ${localStorage.getItem('jwt')}`
        request.headers['Content-Type'] = 'multipart/form-data'

        return request
    },
    error => {
        console.log(error)
    }
);

export const darkSoresApi = {
    getDarkStore(city: string, start_date_from: string, end_date_to: string, offset: number){
        return instance.get(`/darkstore-data/?city=${city}&start_date_from=${start_date_from}&end_date_to=${end_date_to}&offset=${offset}`)
    },
    getDarkStoreCountData(from: number, to: number, city: string, start_date_from: string, end_date_to: string){
        return instance.get(`/darkstore-data/?kol_vo_tovarov_gt=${from}&kol_vo_tovarov_lt=${to}&city=${city}&start_date_from=${start_date_from}&end_date_to=${end_date_to}`)
    },
    getDarkStoreTopData(city: string, start_date_from: string, end_date_to: string){
        return instance.get(`/darkstore-data/?city=${city}&start_date_from=${start_date_from}&end_date_to=${end_date_to}&top=true`)
    }

}